import { getReferrerVertical } from 'lib/verticalReferrer';
import { assert } from 'lib/errors';

type URLParam = {
    name: string
    value?: string
}

const UTM_TAG_SOURCE = 'oma.almaajo.fi';
const UTM_TAG_MEDIUM = 'almainternal';

export const UTM_CAMPAIGN = Object.freeze({
    HALLINNOI: 'hallinnoi',
    HINTAARVIO: 'hintaarvio',
});

export const UTM_CONTENT = Object.freeze({
    MYY: 'myy',
    HINTALASKURI: 'hintalaskuri',
    REKKARI: 'rekkari',
});

const getUtmCampaignBasedOnUrl = (url: string, name: string): string => {
    const vertical = getReferrerVertical(url) as { name: string };
    assert(vertical?.name, `Invalid UTM url: ${url}`);
    return vertical?.name ? `kiintea_${vertical.name}_${name}` : 'invalid';
};

const getUtmContent = (name: string): string => {
    return `kiintea_painike_${name}`;
};

export const appendUtmTagQueryParamsToUrl = (url:URL, params: Array<URLParam>) => {
    params.forEach((param) => {
        url.searchParams.set(param.name, param.value ?? '');
    });
    return url;
};

export const createUtmTagQueryParams = (url: string, campaign: string, content: string): Array<URLParam> => {
    return [
        { name: 'utm_source', value: UTM_TAG_SOURCE },
        { name: 'utm_medium', value: UTM_TAG_MEDIUM },
        { name: 'utm_campaign', value: getUtmCampaignBasedOnUrl(url, campaign) },
        { name: 'utm_content', value: getUtmContent(content) },
    ];
};

export const createUtmTagUrl = (url: URL, params: Array<URLParam>): URL => {
    if (url.href.indexOf('/sso/refresh')) {
        // handle case where we have /sso/refresh url
        // in that case we need to append the params to the successUrl param instead
        const successHref = url.searchParams.get('successUrl') ?? '';
        const successUrl = appendUtmTagQueryParamsToUrl(new URL(successHref), params);
        url.searchParams.set('successUrl', successUrl.href);
    } else {
        url = appendUtmTagQueryParamsToUrl(url, params);
    }

    return url;
};
